module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [(_vm.componentLoaded) ? _c("inspection-template", {
    ref: "template",
    tag: "component",
    attrs: {
      "inspection": _vm.inspection
    },
    on: {
      "save": _vm.save,
      "submit": _vm.submit,
      "approve": _vm.approve,
      "reject": _vm.reject
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09fced45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/inspections-editor.vue
// module id = 812
// module chunks = 3